import { IBigNumber } from "../Global/Base/DataTypes/IBigNumber";

/**
 * Představuje hodnotu atributu aplikačního objektu (ať už načtenou přes _data reader_ nebo _object reader_).
 * Jelikož zde definované metody (valueOf, toString) má jakýkoli javascriptový objekt (i primitivní typy), tak tento interface splňuje v podstatě cokoliv.
 * Rozhraní pouze označuje fakt, že to má být opravdu hodnota atributu a může mít navíc další metadata.
 * @includeToDoc
 */

export interface IAttrValue {
    /**
     * Skutečná hodnota atributu
     */
    valueOf(): any;
    /**
     * Převede hodnotu atributu na textovou podobu
     */
    toString(): string;
}

export class IAttrValue {
    private static _methods = ["valueOf", "toString"];
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && //!this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}

/**
 * Data jednoho řádku načteného _data readerem_.
 * Klíčem (sloupce) je název aplikačního atributu, hodnotou je struktura obsahující načtená data atributu
 * @includeToDoc
 */
export interface IRowData {
    /** Klíčem (sloupce) je název aplikačního atributu, hodnotou je struktura obsahující načtená data atributu */
    [name: string]: IAttrValue; // TODO Nastavit jako readonly a vytvořit typ IMutableRowData.
}

/**
 * Výsledek agregace několika atributů.
 * @includeToDoc
 */
export interface IAggregationsResult {
    readonly [key: string]: IBigNumber;
}
